import React, { Component } from 'react'
import { compose } from 'react-apollo'

import { logout as logoutMutation } from 'components/Logout/mutations'

import storage from 'storage/index'

import PageLoader from 'components/PageLoader'

class Logout extends Component {
  async componentWillMount() {
    await this.props.logout()

    await storage.removeItem('token')

    window.location = '/'
  }

  render() {
    return (
      <PageLoader />
    )
  }
}

export default compose(
  logoutMutation
)(Logout)



// WEBPACK FOOTER //
// ./src/components/Logout/index.js